import { render, staticRenderFns } from "./tableinfo.vue?vue&type=template&id=cbbc3750&scoped=true"
import script from "./tableinfo.vue?vue&type=script&lang=js"
export * from "./tableinfo.vue?vue&type=script&lang=js"
import style0 from "./tableinfo.vue?vue&type=style&index=0&id=cbbc3750&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbc3750",
  null
  
)

export default component.exports